export default "__VITE_ASSET__BTiSiwrC__"